// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AppContainer__wrapper___22Xvz","container":"AppContainer__container___1-H2F","fixedBackground":"AppContainer__fixedBackground___n6orU"};